export const UTM_DEFAULT_HOME = {
  utm_source: 'direct',
  utm_medium: 'homepage',
  utm_campaign: 'quoteswidget',
};

export const UTM_DEFAULT_AFFILIATE = {
  utm_source: 'shareresults',
  utm_medium: 'affiliate',
  utm_campaign: 'quoteswidget',
};

export function getSubdomain() {
  if (process.env.GATSBY_PM_ENV === 'dev') {
    return 'dev';
  } else if (process.env.GATSBY_PM_ENV === 'test') {
    return 'test';
  }
  return 'www';
}
